var se = (O, b, a) => new Promise((Y, N) => {
  var z = (v) => {
    try {
      V(a.next(v));
    } catch (g) {
      N(g);
    }
  }, F = (v) => {
    try {
      V(a.throw(v));
    } catch (g) {
      N(g);
    }
  }, V = (v) => v.done ? Y(v.value) : Promise.resolve(v.value).then(z, F);
  V((a = a.apply(O, b)).next());
});
import { m as f, a as r, u as ne, o as xe, b as Ve, c as s, e as n, g as l, f as o, l as x, w as A, k as i, h as p, t as m, z as c, au as E, i as u, al as h, F as d, p as re } from "./define-element-XpjsV6s1.js";
import { u as Se } from "./use-user-CwEHAZOt.js";
import { u as we } from "./use-config-1FCHS5th.js";
import { S as Ue } from "./constants-S7QMI5p0.js";
import { I as k } from "./Input-yplyeePD.js";
import { B as Me } from "./Button-D5lKR5Sd.js";
import { S as ee } from "./Select-CfkMpX3N.js";
import { D as Ce } from "./DateOfBirth-C57dVBDY.js";
import { A as ue } from "./Address-QnUa_uo4.js";
import { R as Pe } from "./ReferralNote-SzjhZsM4.js";
import { T as Te } from "./Textarea-DR6xAbu0.js";
import { _ as qe } from "./_plugin-vue_export-helper-CHgC5LLL.js";
const Ie = { class: "grouped" }, Ae = {
  key: 0,
  class: "age-restriction-notice"
}, Ne = { class: "grouped" }, Be = {
  key: 1,
  class: "sms-opt-in"
}, De = { class: "sms-opt-in-label" }, Re = { class: "sms-opt-in-terms" }, Ee = ["href"], Oe = ["href"], Ye = ["href"], ze = {
  key: 0,
  class: "error"
}, Fe = {
  key: 1,
  class: "error"
}, Le = ["value", "textContent"], We = {
  key: 3,
  class: "mailing-address-section"
}, je = { class: "mailing-opt-in-label" }, He = ["value", "textContent"], $e = {
  key: 6,
  class: "comments-section"
}, Ze = {
  key: 0,
  class: "comments-heading"
}, Ge = { class: "consent-section" }, Je = { class: "consent-label" }, Ke = ["aria-expanded"], Qe = { class: "consent-label" }, Xe = {
  key: 0,
  class: "error"
}, he = ["textContent"], et = {
  __name: "SubscribeForm",
  props: {
    inheritStyle: {
      type: String,
      default: "all"
    },
    subscribeText: {
      type: String,
      default: "Create Account"
    },
    subscribingText: {
      type: String,
      default: "Creating account..."
    },
    context: {
      type: String,
      default: "signup"
      // "signup" | "cart" | "club" | "event" | "tasting" | "visit"
    }
  },
  setup(O) {
    const b = O, { config: a } = we(), Y = f(() => b.context === "cart" ? "Open Cart" : b.context === "club" ? "Club" : "Web"), N = f(() => {
      var e;
      return (e = {
        cart: "Cart",
        club: "Club",
        event: "Event",
        tasting: "Tasting",
        visit: "Visit"
      }[b.context]) != null ? e : "Sign Up";
    }), z = f(() => b.context === "cart" ? a.value.cart_signup_group || a.value.default_group || "" : b.context === "club" ? a.value.enable_default_group_in_club !== !1 ? a.value.default_group || "" : 0 : a.value.default_group || ""), F = f(() => a.value.default_customer_type || "Mailing List"), V = f(() => {
      var y;
      return ((y = a.value.list_customer_answers) != null ? y : "").split(/\r?\n/).filter(Boolean);
    }), { subscribeMutation: v, prefilledData: g } = Se(), {
      mutate: ie,
      isPending: de,
      isError: me,
      error: pe
    } = v, L = r(""), W = r(!1), S = r(!1), w = r(!1), te = "consent-purpose-" + Math.random().toString(36).substring(2), B = r(!1), D = r(!1), U = r("US"), M = r(""), C = r(""), P = r(""), T = r(""), q = r(""), j = r(""), H = r(""), $ = r(""), I = r(""), Z = r(g.value.first_name), G = r(g.value.last_name), J = r(g.value.email), K = r(g.value.phone), Q = r(g.value.birthday), _ = r(""), R = r(""), X = r(""), ae = f(() => _.value && R.value && _.value !== R.value), le = f(() => _.value && _.value.length < 8), oe = r(!1), ve = f(() => oe.value && !S.value), ge = ne("container"), fe = ne("dob"), be = f(() => a.value.enable_age_restriction ? parseInt(a.value.restriction_age) || 21 : 0);
    function ye() {
      return Math.random().toString(36).substring(2, 11) + Math.random().toString(36).substring(2, 11);
    }
    function _e(y = 12) {
      const e = "234567890abcdefghjklmnpqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ-$!", t = new Uint32Array(y);
      return crypto.getRandomValues(t), Array.from(t, (ke) => e[ke % e.length]).join("");
    }
    function ce(y) {
      return se(this, null, function* () {
        var t;
        if (y.preventDefault(), oe.value = !0, a.value.enable_password_entry_web && (ae.value || le.value) || (t = fe.value) != null && t.isUnderAge || !S.value)
          return;
        const e = /* @__PURE__ */ new Date();
        yield ie({
          salutation: L.value || void 0,
          first_name: Z.value,
          last_name: G.value,
          email: J.value,
          phone: K.value || void 0,
          password: a.value.enable_password_entry_web ? _.value : _e(),
          state: X.value,
          birthday: Q.value,
          receive_text_messages: B.value ? "Yes" : "No",
          mail_marketing_opt_in: D.value ? "Yes" : "No",
          mailing_country: U.value,
          mailing_address: M.value,
          mailing_address_2: C.value,
          mailing_city: P.value,
          mailing_state: T.value,
          mailing_zip: q.value,
          referral_source: j.value || void 0,
          referral_note: H.value || void 0,
          customer_signup_answer: $.value || void 0,
          comments: I.value || void 0,
          marketing_opt_in: W.value ? "Yes" : "No",
          agreed_to_terms_privacy: S.value ? "Yes" : "No",
          agreed_to_mailing_list: "Yes",
          consent_date: e.toISOString().split("T")[0],
          consent_time: e.toTimeString().split(" ")[0],
          consent_token: ye(),
          group_id: z.value,
          customer_source: Y.value,
          page_source: N.value,
          customer_type: F.value
        });
      });
    }
    return xe(() => {
      Ve(ge.value, b.inheritStyle);
    }), (y, e) => (s(), n("form", {
      onSubmit: ce,
      ref: "container",
      class: "offset-subscribe-form"
    }, [
      l("div", Ie, [
        o(a).enable_salutation ? (s(), x(ee, {
          key: 0,
          modelValue: L.value,
          "onUpdate:modelValue": e[0] || (e[0] = (t) => L.value = t),
          label: "Title",
          required: "",
          floating: !0
        }, {
          default: A(() => e[31] || (e[31] = [
            l("option", {
              value: "",
              disabled: "",
              selected: ""
            }, null, -1),
            l("option", { value: "Mr." }, "Mr.", -1),
            l("option", { value: "Mrs." }, "Mrs.", -1),
            l("option", { value: "Ms." }, "Ms.", -1),
            l("option", { value: "Mr. & Mrs." }, "Mr. & Mrs.", -1),
            l("option", { value: "Mr. &  Mr." }, "Mr. & Mr.", -1),
            l("option", { value: "Mrs. &  Mrs." }, "Mrs. & Mrs.", -1),
            l("option", { value: "Mx." }, "Mx.", -1),
            l("option", { value: "Dr." }, "Dr.", -1),
            l("option", { value: "Rev." }, "Rev.", -1),
            l("option", { value: "Prof." }, "Prof.", -1)
          ])),
          _: 1,
          __: [31]
        }, 8, ["modelValue"])) : i("", !0),
        p(k, {
          type: "text",
          modelValue: Z.value,
          "onUpdate:modelValue": e[1] || (e[1] = (t) => Z.value = t),
          label: "First Name",
          required: "",
          floating: !0
        }, null, 8, ["modelValue"]),
        p(k, {
          type: "text",
          modelValue: G.value,
          "onUpdate:modelValue": e[2] || (e[2] = (t) => G.value = t),
          label: "Last Name",
          required: "",
          floating: !0
        }, null, 8, ["modelValue"])
      ]),
      o(a).enable_age_restriction ? (s(), n("p", Ae, " You must be " + m(o(a).restriction_age || 21) + " or older. ", 1)) : i("", !0),
      p(Ce, {
        ref: "dob",
        modelValue: Q.value,
        "onUpdate:modelValue": e[3] || (e[3] = (t) => Q.value = t),
        "min-age": be.value,
        required: ""
      }, null, 8, ["modelValue", "min-age"]),
      l("div", Ne, [
        p(k, {
          type: "email",
          modelValue: J.value,
          "onUpdate:modelValue": e[4] || (e[4] = (t) => J.value = t),
          label: "Email",
          required: "",
          floating: !0
        }, null, 8, ["modelValue"]),
        o(a).enable_text_alerts || o(a).enable_mobile_phone_signup !== !1 ? (s(), x(k, {
          key: 0,
          type: "tel",
          modelValue: K.value,
          "onUpdate:modelValue": e[5] || (e[5] = (t) => K.value = t),
          label: "Mobile Phone",
          required: "",
          floating: !0
        }, null, 8, ["modelValue"])) : i("", !0)
      ]),
      o(a).enable_text_alerts ? (s(), n("div", Be, [
        l("label", De, [
          c(l("input", {
            type: "checkbox",
            "onUpdate:modelValue": e[6] || (e[6] = (t) => B.value = t)
          }, null, 512), [
            [E, B.value]
          ]),
          e[32] || (e[32] = l("strong", null, "Yes", -1)),
          u(", I'd like to receive texts from " + m(o(a).company_name) + ". ", 1)
        ]),
        c(l("div", Re, [
          o(a).enable_redchirp ? (s(), n(d, { key: 0 }, [
            u(" By checking this box, I give " + m(o(a).company_name) + " permission to send text messages with info, promotions, and offers to the number I have provided, including use of an automated system. Consent is not a condition of purchase. Texts are recorded. Message and/or data rates may apply. Message frequency varies. Text STOP to opt out or HELP for help at any time. Use is subject to ", 1),
            l("a", {
              href: o(a).redchirp_text_terms,
              target: "_blank"
            }, "Terms", 8, Ee),
            e[33] || (e[33] = u(" with an arbitration clause and a ", -1)),
            l("a", {
              href: o(a).redchirp_text_privacy,
              target: "_blank"
            }, "Privacy Policy", 8, Oe),
            e[34] || (e[34] = u(". ", -1))
          ], 64)) : (s(), n(d, { key: 1 }, [
            o(a).slick_text_textcount ? (s(), n(d, { key: 0 }, [
              u(m(o(a).slick_text_textcount) + " ", 1)
            ], 64)) : i("", !0),
            e[35] || (e[35] = u(" Message and data rates may apply. Reply STOP to cancel, HELP for help. ", -1)),
            o(a).slick_text_terms ? (s(), n("a", {
              key: 1,
              href: `https://${o(a).slick_text_terms}`,
              target: "_blank"
            }, "Text Terms", 8, Ye)) : i("", !0)
          ], 64))
        ], 512), [
          [h, B.value]
        ])
      ])) : i("", !0),
      o(a).enable_password_entry_web ? (s(), n(d, { key: 2 }, [
        p(k, {
          type: "password",
          modelValue: _.value,
          "onUpdate:modelValue": e[7] || (e[7] = (t) => _.value = t),
          label: "Password",
          required: "",
          floating: !0
        }, {
          default: A(() => e[36] || (e[36] = [
            l("em", null, "Must be at least 8 characters and not a common password", -1)
          ])),
          _: 1,
          __: [36]
        }, 8, ["modelValue"]),
        p(k, {
          type: "password",
          modelValue: R.value,
          "onUpdate:modelValue": e[8] || (e[8] = (t) => R.value = t),
          label: "Confirm Password",
          required: "",
          floating: !0
        }, null, 8, ["modelValue"]),
        ae.value ? (s(), n("em", ze, "Passwords do not match")) : i("", !0),
        le.value ? (s(), n("em", Fe, "Password must be at least 8 characters")) : i("", !0)
      ], 64)) : i("", !0),
      p(ee, {
        modelValue: X.value,
        "onUpdate:modelValue": e[9] || (e[9] = (t) => X.value = t),
        label: "State",
        required: "",
        floating: !0
      }, {
        default: A(() => [
          e[37] || (e[37] = l("option", {
            value: "",
            disabled: "",
            selected: ""
          }, "Select a state", -1)),
          (s(!0), n(d, null, re(o(Ue), (t) => (s(), n("option", {
            value: t,
            textContent: m(t)
          }, null, 8, Le))), 256))
        ]),
        _: 1,
        __: [37]
      }, 8, ["modelValue"]),
      o(a).enable_signup_mailing_address_web ? (s(), n("div", We, [
        o(a).enable_require_mailing_address ? (s(), n(d, { key: 0 }, [
          e[38] || (e[38] = l("h3", { class: "mailing-address-heading" }, [
            u(" Mailing Address "),
            l("span", { class: "required" }, "*")
          ], -1)),
          p(ue, {
            country: U.value,
            "onUpdate:country": e[10] || (e[10] = (t) => U.value = t),
            address: M.value,
            "onUpdate:address": e[11] || (e[11] = (t) => M.value = t),
            address2: C.value,
            "onUpdate:address2": e[12] || (e[12] = (t) => C.value = t),
            city: P.value,
            "onUpdate:city": e[13] || (e[13] = (t) => P.value = t),
            state: T.value,
            "onUpdate:state": e[14] || (e[14] = (t) => T.value = t),
            zip: q.value,
            "onUpdate:zip": e[15] || (e[15] = (t) => q.value = t)
          }, null, 8, ["country", "address", "address2", "city", "state", "zip"])
        ], 64)) : (s(), n(d, { key: 1 }, [
          l("label", je, [
            c(l("input", {
              type: "checkbox",
              "onUpdate:modelValue": e[16] || (e[16] = (t) => D.value = t)
            }, null, 512), [
              [E, D.value]
            ]),
            e[39] || (e[39] = l("strong", null, "Yes", -1)),
            e[40] || (e[40] = u(", ", -1)),
            o(a).mailing_address_title ? (s(), n(d, { key: 0 }, [
              u(m(o(a).mailing_address_title), 1)
            ], 64)) : (s(), n(d, { key: 1 }, [
              u("I'd like to receive postal mail from " + m(o(a).company_name) + ".", 1)
            ], 64))
          ]),
          c(l("div", null, [
            p(ue, {
              country: U.value,
              "onUpdate:country": e[17] || (e[17] = (t) => U.value = t),
              address: M.value,
              "onUpdate:address": e[18] || (e[18] = (t) => M.value = t),
              address2: C.value,
              "onUpdate:address2": e[19] || (e[19] = (t) => C.value = t),
              city: P.value,
              "onUpdate:city": e[20] || (e[20] = (t) => P.value = t),
              state: T.value,
              "onUpdate:state": e[21] || (e[21] = (t) => T.value = t),
              zip: q.value,
              "onUpdate:zip": e[22] || (e[22] = (t) => q.value = t)
            }, null, 8, ["country", "address", "address2", "city", "state", "zip"])
          ], 512), [
            [h, D.value]
          ])
        ], 64))
      ])) : i("", !0),
      o(a).enable_how_did_you_hear_about_us ? (s(), x(Pe, {
        key: 4,
        source: j.value,
        "onUpdate:source": e[23] || (e[23] = (t) => j.value = t),
        note: H.value,
        "onUpdate:note": e[24] || (e[24] = (t) => H.value = t),
        required: ""
      }, null, 8, ["source", "note"])) : i("", !0),
      o(a).enable_signup_questions ? (s(), x(ee, {
        key: 5,
        modelValue: $.value,
        "onUpdate:modelValue": e[25] || (e[25] = (t) => $.value = t),
        label: o(a).customer_question,
        required: "",
        floating: !0
      }, {
        default: A(() => [
          e[41] || (e[41] = l("option", {
            value: "",
            disabled: "",
            selected: ""
          }, "Select an answer", -1)),
          (s(!0), n(d, null, re(V.value, (t) => (s(), n("option", {
            key: t,
            value: t,
            textContent: m(t)
          }, null, 8, He))), 128))
        ]),
        _: 1,
        __: [41]
      }, 8, ["modelValue", "label"])) : i("", !0),
      o(a).enable_signup_referral_note ? (s(), n("div", $e, [
        o(a).comments_title ? (s(), n("h3", Ze, m(o(a).comments_title), 1)) : i("", !0),
        o(a).enable_signup_referral_note_large ? (s(), x(Te, {
          key: 1,
          modelValue: I.value,
          "onUpdate:modelValue": e[26] || (e[26] = (t) => I.value = t),
          label: "Comments",
          floating: !0,
          rows: "4"
        }, null, 8, ["modelValue"])) : (s(), x(k, {
          key: 2,
          type: "text",
          modelValue: I.value,
          "onUpdate:modelValue": e[27] || (e[27] = (t) => I.value = t),
          label: "Comments",
          floating: !0
        }, null, 8, ["modelValue"]))
      ])) : i("", !0),
      l("div", Ge, [
        e[48] || (e[48] = l("h3", { class: "consent-heading" }, "Consent", -1)),
        l("label", Je, [
          c(l("input", {
            type: "checkbox",
            "onUpdate:modelValue": e[28] || (e[28] = (t) => W.value = t),
            required: ""
          }, null, 512), [
            [E, W.value]
          ]),
          l("span", null, [
            e[42] || (e[42] = l("strong", null, "I agree", -1)),
            u(" to subscribe to communication from " + m(o(a).company_name) + ". ", 1),
            l("button", {
              type: "button",
              class: "consent-purpose-toggle",
              "aria-expanded": w.value,
              "aria-controls": te,
              onClick: e[29] || (e[29] = (t) => w.value = !w.value)
            }, m(w.value ? "Close" : "Purpose"), 9, Ke)
          ])
        ]),
        c(l("div", {
          id: te,
          class: "consent-purpose"
        }, [
          l("p", null, [
            e[43] || (e[43] = l("strong", null, "Purpose of personal data usage", -1)),
            e[44] || (e[44] = l("br", null, null, -1)),
            e[45] || (e[45] = u(" We send offers, news, and announcements via email", -1)),
            o(a).enable_text_alerts ? (s(), n(d, { key: 0 }, [
              u(", text,")
            ], 64)) : i("", !0),
            e[46] || (e[46] = u(" and/or post. We keep track of your contact information, order history, and your general preferences to maintain compliance with applicable laws. ", -1))
          ])
        ], 512), [
          [h, w.value]
        ]),
        l("label", Qe, [
          c(l("input", {
            type: "checkbox",
            "onUpdate:modelValue": e[30] || (e[30] = (t) => S.value = t),
            required: ""
          }, null, 512), [
            [E, S.value]
          ]),
          e[47] || (e[47] = l("span", null, [
            l("strong", null, "I agree"),
            u(" to the "),
            l("a", {
              href: "/terms/",
              target: "_blank"
            }, "Terms"),
            u(" and "),
            l("a", {
              href: "/privacy/",
              target: "_blank"
            }, "Privacy Policy"),
            u(" of this website. "),
            l("span", { class: "required" }, "*")
          ], -1))
        ]),
        ve.value ? (s(), n("em", Xe, "You must agree to the Terms and Privacy Policy")) : i("", !0)
      ]),
      o(me) ? (s(), n("em", {
        key: 7,
        class: "error",
        textContent: m(o(pe).message)
      }, null, 8, he)) : i("", !0),
      p(Me, { type: "submit" }, {
        default: A(() => [
          o(de) ? (s(), n(d, { key: 0 }, [
            u("Creating account...")
          ], 64)) : (s(), n(d, { key: 1 }, [
            u("Create Account")
          ], 64))
        ]),
        _: 1
      })
    ], 544));
  }
}, gt = /* @__PURE__ */ qe(et, [["__scopeId", "data-v-906043de"]]);
export {
  gt as S
};
